export default "__VITE_PUBLIC_ASSET__72396231__"